export default "__VITE_ASSET__CmIPoE0G__"